export const API_BASE_URL = 'https://linklift.cc';

export const APP_BASE_URL = 'linklift.cc';

export const getAppUrl = (path: string): string => {
    return `${API_BASE_URL}/${path}`;
};

